import { PersonalizationProductSourceSelectorDialog } from './web-components/personalization-product-source-selector-dialog/personalization-product-source-selector-dialog';

window.customElements.define(
  PersonalizationProductSourceSelectorDialog.elementName,
  PersonalizationProductSourceSelectorDialog
);
